<template>
    <div v-if="totalPaginas > 1" class="tw:flex tw:flex-row tw:items-center tw:justify-center tw:gap-1 tw:md:justify-end">
        <Button
            variant="pagination"
            icon="fas fa-angle-double-left"
            :disabled="currentPage === 1"
            aria-label="Primera página"
            title="Primera página"
            @click="changePage(1)"
        />
        <Button
            variant="pagination"
            icon="fas fa-angle-left"
            :disabled="currentPage === 1"
            aria-label="Página anterior"
            title="Página anterior"
            @click="changePage(currentPage - 1)"
        />
        <Button
            v-for="p in paginasVisibles"
            :key="p"
            :variant="p === currentPage ? 'pagination-active' : 'pagination'"
            class="tw:hidden tw:md:flex"
            :aria-label="`Página ${p}`"
            :title="`Página ${p}`"
            @click="changePage(p)"
        >
            {{ p }}
        </Button>
        <Button
            variant="pagination"
            icon="fas fa-angle-right"
            :disabled="currentPage === totalPaginas"
            aria-label="Página siguiente"
            title="Página siguiente"
            @click="changePage(currentPage + 1)"
        />
        <Button
            variant="pagination"
            icon="fas fa-angle-double-right"
            :disabled="currentPage === totalPaginas"
            aria-label="Última página"
            title="Última página"
            @click="changePage(totalPaginas)"
        />
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        value: { type: Number, required: true },
        total: { type: Number, required: true },
        perPage: { type: Number, default: 5 }
    })

    const emit = defineEmits(['input'])

    const totalPaginas = computed(() => Math.ceil(props.total / props.perPage))
    const currentPage = computed(() => props.value)

    const paginasVisibles = computed(() => {
        const rango = 2
        const inicio = Math.max(1, currentPage.value - rango)
        const fin = Math.min(totalPaginas.value, currentPage.value + rango)
        const paginas = []
        for (let i = inicio; i <= fin; i++) paginas.push(i)
        return paginas
    })

    function changePage(page) {
        if (page < 1 || page > totalPaginas.value) return
        emit('input', page)
    }
</script>